import React, { Component } from 'react';
import handleViewport from 'react-in-viewport';

import './Imagecard.scss';


class ImagecardSection extends Component {

  constructor(props) {
    super(props);

    this.state = { loaded: false, hover : false};

    this.card = React.createRef();

    this._handleMouseEnter = this.handleMouseEnter.bind(this);
    this._handleMouseLeave = this.handleMouseLeave.bind(this);
    this._handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentDidMount() {

  }

  handleImageLoaded() {
    this.setState({ loaded: true });
  }

   handleMouseEnter() {
     this.setState({ hover: true });
     if (this.props.cinema) {
       document.body.classList.add('body--cinema');

     }
   }

   handleMouseLeave() {
     this.setState({ hover: false });
     if (this.props.cinema) {
       document.body.classList.remove('body--cinema');
    }
  }

  isInview() {
     const { inViewport, enterCount } = this.props;

     let inview = true;
     if (inViewport && enterCount === 1) {
       inview = true;
     } else if (!inViewport && enterCount < 1) {
       inview = false;
     }

     return inview;

  }


  render() {

    const ratio = this.props.ratio;
    const align = this.props.align;
    const ratioClass = (ratio) ? ratio : 'regular';
    const alignClass = (align) ? align : 'align--none';
    const loadedClass = (this.state.loaded) ? 'loaded' : '';
    const hoverClass = (this.state.hover) ? 'hover' : '';

    let inviewClass = (this.isInview()) ? 'inview' : '';

    return (
      <div className={`imagecard ${loadedClass} ${ratioClass} ${hoverClass} ${alignClass} ${inviewClass}`} ref={this.card}>
          <div className="imagecard__inner">
            <div className="imagecard__media">
              <div className="imagecard__media__inner">
                <img src={this.props.image} alt={this.props.alt} onLoad={this.handleImageLoaded.bind(this)} />
              </div>
            </div>
          </div>
      </div>
    )
  }
}

const Imagecard = handleViewport(ImagecardSection, { rootMargin: '-1.0px' });

export default Imagecard;
